import moment from "moment"


export const formatDateWithTime = (date, inputFormat = 'YYYY/MM/DD HH:mm:ss ZZ', outputFormat = 'DD/MM/YYYY HH:mm') => {
    return moment(date, inputFormat).format(outputFormat)
}

export const formatDateWithoutTime = (date, inputFormat = 'YYYY/MM/DD HH:mm:ss ZZ', outputFormat = 'DD/MM/YYYY') => {
    return moment(date, inputFormat).format(outputFormat)
}